import { getAnswersToSend } from 'modules/survey/helpers';
import { IParams } from 'interfaces';
import { SurveyAnswers } from '@verv-inc/js-questionnaire';
import { IUserData, SUBSCRIPTION_SOURCE } from './VervAPITypes';
import { IExtraDataPromocode, SURVEY_CONFIG } from 'types';

export interface IVervAPIRequestHelper {
	getUserDataRequest: (data: SurveyAnswers) => IUserData;
}

interface Props {
	config: SURVEY_CONFIG;
	extraDataPromocode: IExtraDataPromocode | undefined;
	bundleId: string;
	sourceUrl?: string;
}

export const VervAPIRequestHelper = (props: Props): IVervAPIRequestHelper => {
	const { config, extraDataPromocode, bundleId, sourceUrl } = props;

	const getUserDataRequest = (answers: SurveyAnswers): IUserData => {
		const { promocode } = extraDataPromocode ?? {};
		const { mail, mail4, agreeToInbox, email_permission, ob_email, ob_email_concent } = answers;
		const email = mail || mail4 || ob_email;
		const marketing_consent =
			agreeToInbox?.join() === 'true' ||
			email_permission?.join() === 'true' ||
			ob_email_concent?.join() === 'true';

		const source =
			config === SURVEY_CONFIG.ACADEMY ||
			config === SURVEY_CONFIG.ACADEMYV3 ||
			config === SURVEY_CONFIG.ACADEMYV3FSV2
				? SUBSCRIPTION_SOURCE.ACADEMY
				: undefined;

		return {
			bundle_id: bundleId,
			promocode,
			marketing_consent,
			email: email != null ? email?.join() : undefined,
			...(source && { source }),
			extra_data: {
				source_url: sourceUrl,
				user_data: getAnswersToSend(answers),
			},
		};
	};

	return {
		getUserDataRequest,
	};
};
